var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { connect } from "react-redux";
import { injectIntl, defineMessages } from "react-intl";
import GameCard from "../GameCard";
import { CardBody, BtnLoadMore } from "../styles";
import { clearGames } from "../../../../actions/games/creators";
import { getDocHeight, getScrollXY } from "./lib";
var messages = defineMessages({
    load_more: {
        id: "games.load_more",
        defaultMessage: "Еще",
    },
    loading: {
        id: "loading",
        defineMessages: "Загрузка..."
    }
});
var GameList = /** @class */ (function (_super) {
    __extends(GameList, _super);
    function GameList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleScroll = function () {
            var _a = _this.props.data, TotalCount = _a.TotalCount, Items = _a.Items;
            try {
                if (getDocHeight() - 200 <= getScrollXY()[1] + window.innerHeight) {
                    if (TotalCount > Items.length) {
                        _this.getGames(true);
                    }
                }
            }
            catch (error) {
                console.error(error);
            }
        };
        _this.getGames = function (isMore) {
            var _a = _this.props, gamblerId = _a.gamblerId, data = _a.data, params = _a.params, isLoading = _a.isLoading;
            if (isLoading)
                return;
            _this.props.fetchData(__assign(__assign({}, params), { gamblerId: gamblerId, offset: data.Offset + (isMore ? data.Limit : 0), limit: data.Limit }));
        };
        return _this;
    }
    GameList.prototype.componentDidMount = function () {
        window.scrollTo(0, 0);
        window.addEventListener("scroll", this.handleScroll);
        this.getGames();
    };
    GameList.prototype.componentWillUnmount = function () {
        this.props.clearGamesAction();
        window.removeEventListener("scroll", this.handleScroll);
    };
    GameList.prototype.render = function () {
        var _this = this;
        var _a = this.props, data = _a.data, isLoading = _a.isLoading, onlyPinned = _a.onlyPinned;
        var games = data.Items, TotalCount = data.TotalCount;
        var filteredGames = onlyPinned
            ? games.filter(function (game) { return game.IsPinned; })
            : games;
        return (_jsxs("div", { children: [_jsx(CardBody, { children: filteredGames &&
                        filteredGames.map(function (game) {
                            return _jsx(GameCard, { game: game }, game.Id);
                        }) }), games && TotalCount > games.length && (_jsx(BtnLoadMore, __assign({ onClick: function () { return _this.getGames(true); }, disabled: isLoading }, { children: isLoading ? this.props.intl.formatMessage(messages.loading) : this.props.intl.formatMessage(messages.load_more) })))] }));
    };
    return GameList;
}(React.Component));
var mapStateToProps = function (state, props) {
    var _a = state.params, params = _a === void 0 ? {} : _a, games = state.games;
    var onlyPinned = props.onlyPinned;
    var _b = games.games, data = _b.data, error = _b.error, isLoading = _b.isLoading;
    var openGamesLoading = games.openGame.isLoading;
    return {
        onlyPinned: onlyPinned,
        params: params,
        data: data,
        error: error,
        isLoading: isLoading,
        openGamesLoading: openGamesLoading,
        gamblerId: state.auth.user.gamblerId,
        langId: state.application.get("languageId"),
        darkTheme: state.application.get("darkTheme"),
    };
};
var mapDispatchToProps = {
    clearGamesAction: clearGames,
};
export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(GameList));



// WEBPACK FOOTER //
// ./src/components/games/components/GamesList/index.jsx